<template>
  <div style="text-align: right">
    <v-hover>
      <template v-slot="{ hover }">
        <v-card
          class="clickable"
          :elevation="hover ? 24 : 6"
          height="90"
          color="#ebecf0"
          max-width="220"
          rounded="xl"
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title
                class="headline mb-1"
                style="font-size: 14px !important"
              >
                <b>EF2677</b>
              </v-list-item-title>
              <v-list-item-subtitle
                style="font-size: 10px; padding-top: -10px; margin: 0"
                >Crazyflight Shoes</v-list-item-subtitle
              >
              <v-list-item-subtitle
                style="font-size: 10px; padding-top: -10px; margin: 0"
                >Optimize filesize</v-list-item-subtitle
              >
              <v-list-item-subtitle
                style="font-size: 10px; padding-top: -10px; margin: 0"
                >Clean UVs</v-list-item-subtitle
              >
              <v-list-item-subtitle
                style="font-size: 10px; padding-top: -10px; margin: 0"
                >Optimize filesize</v-list-item-subtitle
              >
            </v-list-item-content>

            <v-list-item-avatar
              circle
              size="40"
              color="grey"
            ></v-list-item-avatar>
          </v-list-item>
        </v-card>
      </template>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: "notification",
  data: function () {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.notification_container {
  width: 100%;
  //padding-top: 10px;
  text-align: right;
  border-radius: 10px;
  font-family: "Raleway";
}
.clickable {
  cursor: pointer;
}
</style>